import React from "react";
import { Box } from "@mui/material";
import {IconSeeker} from "@ui-seeker/core";

import {customerDetailsFilters} from "../../@signals";

export default function nameColumn() {
    return {
        name: 'keywordName', label: 'Keyword Name',
        options: {
            headerAlign: 'center',
            setCellProps: () => ({ sx: { textAlign: "center" } })
        }
    }
}